module.exports = __webpack_public_path__ + "img/fund-step7-en.cda2052c.png";